<template>
  <div class="paymentDetail">
    <base-title text="購入詳細" type="back" :href="`${chounEnvDomain}/payment/history`" />
    <FortuneItem
      v-if="menuArray" 
       class="menuDetail"
      :image-path="menuArray.teller_image_url"
      :title="menuArray.menu_title"
      :payment-status="chounUser.status"
    />
    <div class="itemDate">
      <div class="title">
        <p>購入日</p>
        <p v-if="chounUser.status == status.KAIYAKU_YOTEI || chounUser.status == status.KAIYAKU_ZUMI">
          閲覧終了日
        </p>
      </div>
      <div class="date">
        <p>{{ chounUser.current_period_from | convertSlashYMD }}</p>
        <p v-if="chounUser.status == status.KAIYAKU_YOTEI || chounUser.status == status.KAIYAKU_ZUMI">{{ chounUser.current_period_to | convertSlashYMD }}</p>
      </div>
    </div>
    <AttentionChoun v-if="chounUser.status == status.TEISI" class="attention" :text="attentionMsg" />
    <div class="paymentMethod">
      <p v-if="chounUser.status == status.KEIZOKU || chounUser.status == status.TEISI" class="method">支払い方法：{{ paymentMethod }}</p>
      <p v-if="chounUser.status == status.KEIZOKU" class="billingDate">次回請求日は{{ chounUser.next_payment_due | convertKanjiYMD }}です。</p>
    </div>
    <template v-if="chounUser.payee === 'SBPS-credit'">
      <app-loading v-if="isLoading" class="loading--card" :isLoading="isLoading" />
      <CardInfo 
        v-if="isRegistered && chounUser.status == status.TEISI"
        class="info"
        :card-number="card.number"
        :card-expiration="card.expiration"
      />
    </template>
    <BaseButtonChoun
      v-if="chounUser.status == status.TEISI || chounUser.status == status.KAIYAKU_ZUMI"
      class="rejoinButton"
      :label="chounUser.status == status.TEISI ? '占いを再開する' : 'この商品を購入する'"
      @clicked="toPurchase"
    />
    <NextButton
      v-if="chounUser.status == status.KEIZOKU || chounUser.status == status.TEISI"
      class="cancellationButton"
      style="justify-content: space-between;"
      label="今日の運勢を解約する"
      @clicked="toCancellation"
    />
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex'
import { convertKanjiYMD } from '@/utils/filters'
import * as type from '@/utvStore/store/mutation-types'
import { PAYEE } from '@/CONSTS/'
import getChounEnvDomain from '@/utils/getChounEnvDomain'
import moment from 'moment'
import fetchAccountData from '@/utils/fetchAccountData'
import NextButton from '../common/NextButton'
import CardInfo from '../partials/CardInfo'

import AttentionChoun from './partials/AttentionChoun'
import StatusLabel from './partials/StatusLabel'
import FortuneItem from './partials/FortuneItem'
import BaseButtonChoun from './partials/BaseButtonChoun'
import BaseTitle from './partials/BaseTitle'

const STATUS = {
  KEIZOKU: 1,
  TEISI: 2,
  KAIYAKU_YOTEI: 3,
  KAIYAKU_ZUMI: 4
}

export default {
  name: 'PaymentDetailChoun',
  components:{
    AttentionChoun,
    NextButton,
    CardInfo,
    StatusLabel,
    FortuneItem,
    BaseButtonChoun,
    BaseTitle,
  },
  data() {
    return {
      isRegistered: false,
      // 超運Dの環境変数
      chounEnvDomain: getChounEnvDomain(),
      // 登録済みクレカ情報を取得中かどうかに使用
      isLoading: false,
    }
  },
  props: {
    chounUser: {
      type: Object,
      default() {
        return {}
      }
    },
    menuArray: {
      type: Object,
      default() {
        return {}
      }
    },
    diaryToken: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
      userInfo: state => state.account.user,
      subscInfo: state => state.account.subscription
    }),
    ...mapGetters(['isLoggedIn']),
    attentionMsg(){
      return `${convertKanjiYMD(this.chounUser.next_payment_due)}のお引き落としができなかったため、今日の運勢の配信が停止しています。 再開するには<a href="/cd/rejoin/${this.menuArray.menu_id}/${this.diaryToken}" style="color:#FF4438;">こちら</a>からお手続きをお願いします。`
    },
    paymentMethod(){
      return this.chounUser.payee === 'SBPS-credit' ? 'クレジットカード' : 'Amazon Pay'
    },
    status(){
      return STATUS
    }
  },
  created() {
    if (this.isLoggedIn) this.getPaymentInfo()
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        this.isLoading = true
        //カード情報取得
        this.$store.dispatch(type.GET_PAYMENT_INFO, { access_token: this.accessToken,is_choun: 1 })
        .then(()=> {
          this.isRegistered = true
          this.attentionCardExpiration()
          })
        .catch((err)=>console.log('card-unregistered!'))
        .finally(()=>{
          this.isLoading = false
        })
      }
    },
    toCancellation(){
      location.href = `/cd/cancel/${this.menuArray.menu_id}/${this.diaryToken}`
    },
    toPurchase(){
      location.href = `/cd/${this.chounUser.status == this.status.TEISI ? 'rejoin' : 'join'}/${this.menuArray.menu_id}/${this.diaryToken}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/commons/commonVariables.scss";
.paymentDetail{
  color: $col_base_black;
  max-width: 580px;
  margin: auto;

  .menuDetail{
    padding: 13px;
    border-bottom: 1px solid $diary_beige;
    img{
      width: 87px;
      border-radius: 100%;
      margin-right: 12px;
    }
  }

  .itemDate {
    display: flex;
    padding: 16px 20px;
    margin-bottom: 17px;
    border-bottom: 1px solid $diary_beige;
    .title {
      font-size: 12px;
      line-height: 21px;
      color: $diary_text2;
      margin-right: 41px;
      p + p {
        margin-top: 9px;
      }
    }
    .date {
      font-size: 14px;
      line-height: 21px;
      p + p {
        margin-top: 9px;
      }
    }
  }
  .rejoinButton{
    width: 85%;
    margin: 20px auto 40px;
  }
  .cancellationButton{
    border-top: 1px solid $diary_beige;
    border-bottom: 1px solid $diary_beige;
    padding: 13px 20px 12px;
  }
  .paymentMethod {
    padding: 0 15px;
    .method {
      font-size: 14px;
      line-height: 20px;
    }
    .billingDate {
      margin: 14px -7px 16px;
      padding: 8px 12px;
      font-size: 12px;
      line-height: 18px;
      background: $diary_lightyellow;
    }
  }
  .attention{
    margin: 24px 20px 16px;
  }
}
p {
  margin:0
}
.loading {
  &--card {
    margin: 20px auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/PaymentDetailChoun.vue